import { Route, Routes } from 'react-router-dom';

import SignIn from '../pages/Signin';
import SignUp from '../pages/Signup';
import ContactUs from '../components/contactus';
import AboutUs from '../components/aboutus';
import Faqs from '../components/faqs';
import Home from '../pages/Home';


const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/faqs" element={<Faqs />} />
        </Routes>
    );
};

export default AppRoutes;
